module.exports = __webpack_public_path__ + "img/polygon.d9ff3c4d.svg";